import React from 'react';

const SampleView = React.lazy(() => import('./views/SampleView/SampleView'));
// PROJECT OVERVIEW
const ProjectsOverview = React.lazy(
  () => import('./views/Project/ProjectsOverview')
);
const ProjectDetails = React.lazy(
  () => import('./views/Project/ProjectDetails')
);

// DATA MANAGEMENT
const DataIngestion = React.lazy(
  () => import('./views/DataManagement/data-ingestion')
);
const SqlIngestion = React.lazy(
  () => import('./views/DataManagement/sql-ingestion')
);
const DataPreparation = React.lazy(
  () => import('./views/DataManagement/data-preparation')
);
const UploadModel = React.lazy(
  () => import('./views/DataManagement/model-upload')
);

// EDA
const PreliminarySteps = React.lazy(
  () => import('./views/EDA/preliminary-steps')
);

const TreatingOutliers = React.lazy(
  () => import('./views/EDA/treating-outliers')
);

const VariableAnalysis = React.lazy(
  () => import('./views/EDA/variable-analysis')
);

const StatisticalTests = React.lazy(
  () => import('./views/EDA/statistical-tests')
);

const MissingValuesImputation = React.lazy(
  () => import('./views/EDA/missing-values-imputation')
);
const TimeSeriesAnalysis = React.lazy(
  () => import('./views/EDA/time-series-analysis')
);

const FeatureTransformation = React.lazy(
  () => import('./views/FeatureEngineering/FeatureTransformation')
);
const ModelEstimation = React.lazy(
  () => import('./views/ModelEstimation/ModelEstimation')
);

const Segmentation = React.lazy(
  () => import('./views/Segmentation/Segmentation')
);

// SAMPLING
const Sampling = React.lazy(() => import('./views/Sampling/Sampling'));

// VARIABLE REDUCTION
const VariableReduction = React.lazy(
  () => import('./views/VariableReduction/VariableReduction')
);

// MODEL MANAGER
const ModelManager = React.lazy(
  () => import('./views/ModelManager/ModelManager')
);

const ViewModelDetails = React.lazy(
  () => import('./views/ModelManager/ViewModelDetails')
);

const TestCaseManager = React.lazy(
  () => import('./views/ModelManager/TestCaseManager')
);

const ModelsComparisonDialog = React.lazy(
  () => import('./views/ModelManager/ModelComparisonDialog')
);
// MODEL TESTING

const PerformanceTesting = React.lazy(
  () => import('./views/ModelTesting/performance-testing')
);

const AssumptionTesting = React.lazy(
  () => import('./views/ModelTesting/Assumption-testing')
);

const ModelComparison = React.lazy(
  () => import('./views/ModelTesting/model-comparison')
);

const BackTesting = React.lazy(
  () => import('./views/ModelTesting/back-testing')
);

const ModelCalibiration = React.lazy(
  () => import('./views/ModelTesting/model-calibration')
);

const ScoringScaling = React.lazy(
  () => import('./views/ModelTesting/scoring-scaling')
);

const SensitivityAnalysis = React.lazy(
  () => import('./views/ModelTesting/sensitivity-analysis')
);

const Fairness = React.lazy(
  () => import('./views/ModelTesting/fairness-biasness')
);

const DriftAnalysis = React.lazy(
  () => import('./views/ModelTesting/DriftAnalysis')
);

const ForeCasting = React.lazy(
  () => import('./views/ModelTesting/forecasting')
);

// MODEL INTERPRETATION

const FeatureInterpretation = React.lazy(
  () => import('./views/ModelInterpretation/feature-interpretation')
);

const IndividualPrediction = React.lazy(
  () => import('./views/ModelInterpretation/individual-prediction')
);

const DecisionTrees = React.lazy(
  () => import('./views/ModelInterpretation/decision-tree')
);

const MiTimeSeriesAnalysis = React.lazy(
  () => import('./views/ModelInterpretation/time-series-analysis')
);

// MODEL DEPLOYMENT
const ModelDeployment = React.lazy(
  () => import('./views/ModelDeployment/ModelDeployment')
);

// DOCUMENT MANAGER ROUTES
const ListDocuments = React.lazy(
  () => import('./views/Documentation/ListDocuments')
);
const EditDocTemplate = React.lazy(
  () => import('./views/Documentation/EditDocTemplate')
);

// NEW DOCUMENTATION ROUTES
const ListNewDocuments = React.lazy(
  () => import('./views/NewDocumentation/ListDocuments')
);

const EditorPage = React.lazy(
  () => import('./views/NewDocumentation/DocumentationEditor')
);

const EditorReadOnlyPage = React.lazy(
  () => import('./views/NewDocumentation/FullScreenReadOnlyEditor')
);

// PIPELINES

const ListPipeline = React.lazy(() => import('./views/Pipeline/ListPipeline'));
const EditPipeline = React.lazy(() => import('./views/Pipeline/EditPipeline'));
const PipelineExecutionHistory = React.lazy(
  () => import('./views/Pipeline/PipelineExecutionHistory')
);
const PipelineExecutionResult = React.lazy(
  () => import('./views/Pipeline/PipelineExecutionResult')
);

// UDF Manager

const RunUdf = React.lazy(() => import('./views/UDFManager/RunUdf'));
const FileBrowser = React.lazy(
  () => import('./views/UDFManager/FileBrowserView')
);
const EditUdf = React.lazy(() => import('./views/UDFManager/EditUdf'));
const UDFManager = React.lazy(() => import('./views/UDFManager/UDFManager'));
const UDFDetails = React.lazy(() => import('./views/UDFManager/UDFDetails'));
const CreateUdf = React.lazy(() => import('./views/UDFManager/CreateUdf'));
const CompareResults = React.lazy(
  () => import('./views/UDFManager/CompareResultsDialog')
);
const ExecuteUdf = React.lazy(() => import('./views/UDFManager/ExecuteUdf'));

const PipelineExecutionComparison = React.lazy(
  () => import('./views/Pipeline/PipelineExecutionComparision')
);
// SETTINGS
const ColorPallete = React.lazy(() => import('./views/Settings/ColorPallete'));

// STREAMLIT DASHBOARD
const StreamlitDashboard = React.lazy(
  () => import('./views/StreamlitDashboard/StreamlitDashboard')
);

// DocumentationTemplates
const ListTemplates = React.lazy(
  () => import('./views/DocumentationTemplates/ListTemplates')
);
const EditorPageTemplate = React.lazy(
  () => import('./views/DocumentationTemplates/TemplateEditor')
);

// INVENTORY RECIVED ARTIFACTS
const SentReceivedArtifacts = React.lazy(
  () => import('./views/Project/SentReceivedArtifacts')
);

// USER GROUP PROVISIONING
// const UserGroupProvisioning = React.lazy(
//   () => import('./views/UserGroupProvisioning/UserGroupProvisioning')
// );
// const Auditability = React.lazy(
//   () => import('./views/Auditability/Auditability')
// );

// LOGS
const Logs = React.lazy(() => import('./views/Auditability/Logs'));

const WorkerManagement = React.lazy(
  () => import('./views/WorkerManagement/WorkerManagement')
);

const OrchestrationManagement = React.lazy(
  () => import('./views/OrchestrationManagement/OrchestrationManagement')
);

const ConsoleLibrary = React.lazy(
  () => import('./views/ConsoleLibrary/ConsoleLibrary')
);

const DocumentationTemplate = React.lazy(
  () => import('./views/DocumentationTemplate/DocumentationTemplate')
);

const TaskManager = React.lazy(() => import('./views/TaskManager/TaskManager'));
const TaskDetails = React.lazy(() => import('./views/TaskManager/TaskDetails'));

const PowerBi = React.lazy(() => import('./views/PowerBi/PowerBi'));
const BigData = React.lazy(() => import('./views/BigData/BigData'));
const Downloads = React.lazy(() => import('./views/Downloads/Downloads'));
const APIsAndIntegrations = React.lazy(
  () => import('./views/APIsAndIntegrations/APIsAndIntegrations')
);

const AllowedRoutesWithoutProjectSelection = [
  '/',
  '/project/sent-received-artifacts',
  '/project/overview',
  '/data-management/data-ingestion',
  '/project/details',
  '/data-management/model-upload',
  ...(window.CONFIG.NEW_DOCUMENTATION === 'false'
    ? ['/documentation/list', '/documentation/document']
    : ['/newdocumentation/list']),
  '/model-manager/models',
  '/model-manager/models/:id',
  '/model-manager/models-comparison',
  '/settings/color-palette',
  // '/settings/user-group-provisioning',
  '/settings/streamlit-dashboard',
  // '/user-group-provisioning',
  '/settings/worker-management',
  '/settings/orchestration-management',
  '/settings/download-screen',
  '/settings/console-library',
  '/settings/big-data',
  '/settings/documentation-template',
  '/settings/power-bi',
  '/settings/apis-and-integrations',
  // '/settings/auditability',
  '/settings/logs',
  '/settings/license',
  '/settings/documentation-templates',
  '/settings/documentation-templates/:id',
  '/downloads',
  '/help',
  '/task-manager',
  '/task-manager/details/:id/:type?',
];

const UDFTags = [
  'UDF',
  'CreateUdf',
  'ViewDetails',
  'Execute',
  'RunUdf',
  'DeleteUdf',
  'SaveEditUdf',
  'VersionHistory',
  'ShareSendUdf',
  'ShareAcceptUdf',
  'CloneUdf',
  'Rerun',
  'JobsView',
  'JobsCompare',
  'JobsAddPipeLine',
  'JobsDelete',
  'FileView',
  'FileUpload',
  'FileDownload',
  'FileDelete',
  'DeleteUdf',
  'ConsoleFile',
  'Console',
];

const NavigatingRoutes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/sample-view', name: 'SampleView', component: SampleView },
  {
    path: '/project/sent-received-artifacts',
    name: 'SentReceivedArtifacts',
    component: SentReceivedArtifacts,
    helpSectionTag: ['Project', 'ProjectOverview'],
  },
  {
    path: '/project/overview',
    name: 'ProjectsOverview',
    component: ProjectsOverview,
    helpSectionTag: ['Project', 'ProjectOverview'],
  },
  {
    path: '/project/details',
    name: 'ProjectDetails',
    component: ProjectDetails,
    helpSectionTag: ['Project', 'ProjectOverview'],
  },
  {
    path: '/data-management/data-ingestion',
    name: 'DataIngestion',
    component: DataIngestion,
    helpSectionTag: ['DataManagement', 'DataIngestion'],
  },
  {
    path: '/data-management/data-ingestion/sql-ingestion',
    name: 'SqlInjestion',
    component: SqlIngestion,
    helpSectionTag: ['DataManagement', 'SQLIngestion'],
  },
  {
    path: '/data-management/preparation',
    name: 'DataPreparation',
    component: DataPreparation,
    helpSectionTag: ['DataManagement', 'DataPreparation'],
  },
  {
    path: '/data-management/model-upload',
    name: 'ModelUpload',
    component: UploadModel,
    helpSectionTag: ['DataManagement', 'ModelUpload'],
  },
  {
    path: '/eda/preliminary-steps',
    name: 'PreliminarySteps',
    component: PreliminarySteps,
    helpSectionTag: ['EDA', 'PreliminarySteps'],
  },

  {
    path: '/eda/treating-outliers',
    name: 'TreatingOutliers',
    component: TreatingOutliers,
    helpSectionTag: ['EDA', 'TreatingOutliers'],
  },

  {
    path: '/eda/variable-analysis',
    name: 'VariableAnalysis',
    component: VariableAnalysis,
    helpSectionTag: ['EDA', 'VariableAnalysis'],
  },

  {
    path: '/eda/statistical-tests',
    name: 'StatisticalTests',
    component: StatisticalTests,
    helpSectionTag: ['EDA', 'StatisticalTests'],
  },

  {
    path: '/eda/missing-values-imputation',
    name: 'MissingValuesImputation',
    component: MissingValuesImputation,
    helpSectionTag: ['EDA', 'MissingValuesImputation'],
  },
  {
    path: '/eda/time-series-analysis',
    name: 'TimeSeriesAnalysis',
    component: TimeSeriesAnalysis,
    helpSectionTag: ['EDA', 'TimeSeriesAnalysis'],
  },

  {
    path: '/feature-engineering/feature-transformation',
    name: 'FeatureTransformation',
    component: FeatureTransformation,
    helpSectionTag: ['FeatureEngineering'],
  },

  {
    path: '/sampling-segmentation/sampling',
    name: 'Sampling',
    component: Sampling,
    helpSectionTag: ['SamplingSegmentation', 'Sampling'],
  },

  {
    path: '/sampling-segmentation/segmentation',
    name: 'Segmentation',
    component: Segmentation,
    helpSectionTag: ['SamplingSegmentation', 'Segmentation'],
  },

  {
    path: '/variable-reduction',
    name: 'VariableReduction',
    component: VariableReduction,
    helpSectionTag: ['VariableReduction'],
  },

  {
    path: '/model-testing/performance-testing',
    name: 'PerformanceTesting',
    component: PerformanceTesting,
    helpSectionTag: ['ModelTesting', 'PerformanceTesting'],
  },

  {
    path: '/model-testing/assumption-testing',
    name: 'AssumptionTesting',
    component: AssumptionTesting,
    helpSectionTag: ['ModelTesting', 'AssumptionTesting'],
  },

  {
    path: '/model-testing/model-comparison',
    name: 'ModelComparison',
    component: ModelComparison,
    helpSectionTag: ['ModelTesting', 'ModelComparison'],
  },

  {
    path: '/model-testing/back-testing',
    name: 'BackTesting',
    component: BackTesting,
    helpSectionTag: ['ModelTesting', 'BackTesting'],
  },

  {
    path: '/model-testing/calibiration',
    name: 'ModelCalibiration',
    component: ModelCalibiration,
    helpSectionTag: ['ModelTesting', 'ModelRecaliberation'],
  },

  {
    path: '/model-testing/scoring-scaling',
    name: 'ScoringScaling',
    component: ScoringScaling,
    helpSectionTag: ['ModelTesting', 'ScoringScaling'],
  },

  {
    path: '/model-testing/sensitivity-analysis',
    name: 'SensitivityAnalysis',
    component: SensitivityAnalysis,
    helpSectionTag: ['ModelTesting', 'SensitivityAnalysis'],
  },

  {
    path: '/model-testing/fairness',
    name: 'Fairness',
    component: Fairness,
    helpSectionTag: ['ModelTesting', 'Fairness'],
  },

  {
    path: '/model-testing/drift-analysis',
    name: 'DriftAnalysis',
    component: DriftAnalysis,
    helpSectionTag: ['ModelTesting', 'DriftAnalysis'],
  },

  {
    path: '/model-testing/forecasting',
    name: 'SensitivtyAnalysis',
    component: ForeCasting,
    helpSectionTag: ['ModelTesting', 'Forecasting'],
  },

  {
    path: '/model-estimation/',
    name: 'ModelEstimation',
    component: ModelEstimation,
    helpSectionTag: ['ModelEstimation'],
  },

  {
    path: '/model-interpretation/feature-interpretation',
    name: 'FeatureInterpretation',
    component: FeatureInterpretation,
    helpSectionTag: ['ModelInterpretation', 'FeatureInterpretation'],
  },

  {
    path: '/model-interpretation/individual-prediction',
    name: 'IndividualPrediction',
    component: IndividualPrediction,
    helpSectionTag: ['ModelInterpretation', 'IndividualPrediction'],
  },

  {
    path: '/model-interpretation/decision-trees',
    name: 'DecisionTrees',
    component: DecisionTrees,
    helpSectionTag: ['ModelInterpretation', 'DecisionTrees'],
  },

  {
    path: '/model-interpretation/time-series-analysis',
    name: 'MiTimeSeriesAnalysis',
    component: MiTimeSeriesAnalysis,
    helpSectionTag: ['ModelInterpretation', 'TimeSeriesAnalysis'],
  },
  {
    path: '/model-manager/models',
    name: 'ModelManager',
    component: ModelManager,
    helpSectionTag: ['Models', 'ModelManager'],
    exact: true,
  },
  {
    path: '/model-manager/test-case-manager',
    name: 'TestCaseManager',
    component: TestCaseManager,
    helpSectionTag: ['Models', 'ModelManager', 'TestCaseManager'],
  },
  {
    path: '/model-manager/models/:id',
    name: 'ViewModelDetails',
    component: ViewModelDetails,
    helpSectionTag: ['ModelManager', 'Models'],
    exact: true,
  },
  {
    path: '/model-manager/models-comparison',
    name: 'ModelsComparisonDialog',
    component: ModelsComparisonDialog,
    helpSectionTag: ['ModelManager', 'Models'],
    exact: true,
  },
  {
    path: '/model-deployment',
    name: 'ModelDeployment',
    component: ModelDeployment,
    helpSectionTag: ['ModelDeployment', 'Models'],
  },

  ...(window.CONFIG.NEW_DOCUMENTATION === 'false'
    ? [
        {
          path: '/documentation/list',
          name: 'ListDocuments',
          component: ListDocuments,
          helpSectionTag: ['AutomatedDocumentation'],
        },

        {
          path: '/documentation/document',
          name: 'EditDocTemplate',
          component: EditDocTemplate,
          helpSectionTag: ['AutomatedDocumentation'],
        },
      ]
    : [
        {
          path: '/newdocumentation/list',
          name: 'ListNewDocuments',
          component: ListNewDocuments,
          helpSectionTag: ['Documentation'],
        },
        {
          path: '/newdocumentation/:id',
          name: 'EditNewDocTemplate',
          component: EditorPage,
          helpSectionTag: ['Documentation'],
        },
        {
          path: '/newdocumentation/readonly/:id',
          name: 'EditNewDocTemplate',
          component: EditorReadOnlyPage,
          helpSectionTag: ['Documentation'],
        },
      ]),
  {
    path: '/udf-manager/compare-results',
    name: 'CompareResults',
    exact: true,
    component: CompareResults,
    helpSectionTag: UDFTags,
  },

  {
    path: '/udf-manager/execute/:id',
    name: 'ExecuteUdf',
    exact: true,
    component: ExecuteUdf,
    helpSectionTag: UDFTags,
  },
  {
    path: '/udf-manager/edit/:udfId',
    name: 'EditUdf',
    exact: true,
    component: EditUdf,
    helpSectionTag: UDFTags,
  },
  {
    path: '/udf-manager/create',
    name: 'CreateUdf',
    exact: true,
    component: CreateUdf,
    helpSectionTag: UDFTags,
  },
  {
    path: '/udf-manager/create/:id/debug',
    name: 'RunUdf',
    exact: true,
    component: RunUdf,
    helpSectionTag: UDFTags,
  },
  {
    path: '/udf-manager/edit/:id/code/debug',
    name: 'RunUdf',
    exact: true,
    component: RunUdf,
    helpSectionTag: UDFTags,
  },
  {
    path: '/udf-manager/edit/:id/code',
    name: 'FileBrowser',
    exact: true,
    component: FileBrowser,
    helpSectionTag: UDFTags,
  },
  {
    path: '/udf-manager/list',
    name: 'UDFManager',
    component: UDFManager,
    helpSectionTag: UDFTags,
  },
  {
    path: '/udf-manager/detail/:id',
    name: 'UDFDetails',
    exact: true,
    component: UDFDetails,
    helpSectionTag: UDFTags,
  },
  {
    path: '/udf-manager/detail/:id/debug',
    name: 'RunUdf',
    exact: true,
    component: RunUdf,
    helpSectionTag: UDFTags,
  },
  {
    path: '/pipeline/list',
    name: 'ListPipeline',
    component: ListPipeline,
    helpSectionTag: ['Pipeline'],
  },
  {
    path: '/pipeline/:id/execution',
    name: 'PipelineExecutionHistory',
    component: PipelineExecutionHistory,
    helpSectionTag: ['Pipeline'],
    exact: true,
  },
  {
    path: '/pipeline/:id',
    name: 'EditPipeline',
    exact: true,
    component: EditPipeline,
    helpSectionTag: ['Pipeline'],
  },
  {
    path: '/pipeline/:id/execution/compare/:executionIds',
    name: 'PipelineExecutionComparison',
    exact: true,
    component: PipelineExecutionComparison,
    helpSectionTag: ['Pipeline'],
  },
  {
    path: '/pipeline/:id/execution/:executionid',
    name: 'PipelineExecutionResult',
    exact: true,
    component: PipelineExecutionResult,
    helpSectionTag: ['Pipeline'],
  },
  {
    path: '/downloads',
    name: 'Downloads',
    component: Downloads,
    helpSectionTag: ['Downloads'],
  },
  {
    path: '/settings/color-palette',
    name: 'ColorPalette',
    component: ColorPallete,
    helpSectionTag: ['Settings', 'ColorPalette'],
  },
  {
    path: '/settings/streamlit-dashboard',
    name: 'StreamlitDashboard',
    component: StreamlitDashboard,
    helpSectionTag: ['Settings', 'StreamlitDashboard'],
  },
  {
    path: '/settings/documentation-templates',
    name: 'ListTemplates',
    component: ListTemplates,
    helpSectionTag: ['Settings', 'ListTemplates'],
  },
  {
    path: '/settings/documentation-templates/:id',
    name: 'EditorTemplate',
    component: EditorPageTemplate,
    helpSectionTag: ['Settings', 'Documentation'],
  },
  {
    path: '/settings/logs',
    name: 'Logs',
    component: Logs,
    helpSectionTag: ['Settings'],
  },
  // {
  //   path: '/settings/user-group-provisioning',
  //   name: 'UserGroupProvisioning',
  //   component: UserGroupProvisioning,
  //   helpSectionTag: ['Settings', 'UserManagement'],
  // },
  // {
  //   path: '/settings/auditability',
  //   name: 'Auditability',
  //   component: Auditability,
  //   helpSectionTag: ['Settings', 'Auditability'],
  // },
  {
    path: '/settings/worker-management',
    name: 'WorkerManagement',
    component: WorkerManagement,
    helpSectionTag: ['Settings', 'Workers'],
  },
  {
    path: '/settings/orchestration-management',
    name: 'OrchestrationManagement',
    component: OrchestrationManagement,
    helpSectionTag: ['Settings', 'OrchestrationManagement'],
  },
  {
    path: '/settings/big-data',
    name: 'BigData',
    component: BigData,
    helpSectionTag: ['Settings', 'BigData'],
  },
  {
    path: '/settings/console-library',
    name: 'ConsoleLibrary',
    component: ConsoleLibrary,
    helpSectionTag: ['Settings', 'ConsoleLibrary'],
  },
  ...(window.CONFIG.NEW_DOCUMENTATION === 'false'
    ? [
        {
          path: '/settings/documentation-template',
          name: 'DocumentationTemplate',
          component: DocumentationTemplate,
          helpSectionTag: ['Settings', 'DocumentationTemplate'],
        },
      ]
    : []),
  {
    path: '/settings/power-bi',
    name: 'PowerBi',
    component: PowerBi,
    helpSectionTag: ['Settings', 'PowerBi'],
  },
  {
    path: '/settings/apis-and-integrations',
    name: 'APIsAndIntegrations',
    component: APIsAndIntegrations,
    helpSectionTag: ['Settings', 'APIsAndIntegrations'],
  },
  {
    path: '/settings/streamlit-dashboard',
    name: 'StreamlitDashboard',
    component: StreamlitDashboard,
    helpSectionTag: ['Settings', 'StreamlitDashboard'],
  },
  {
    path: '/task-manager',
    name: 'TaskManager',
    component: TaskManager,
    helpSectionTag: ['TaskManager'],
  },
  {
    path: '/task-manager/details/:id/:type?',
    name: 'TaskDetails',
    component: TaskDetails,
    helpSectionTag: ['TaskManager'],
  },
];

export { NavigatingRoutes, AllowedRoutesWithoutProjectSelection };
